module.exports = __webpack_public_path__ + "pic/15.610f0358.png";